import React from "react";
import { Grid } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import FeedbackIcon from "@mui/icons-material/Feedback";
import InsightsIcon from "@mui/icons-material/Insights";
import DashboardCard from "../../components/DashboardCard";

const BusinessDashboard = () => {
  const cardData = [
    {
      title: "View Business Details & Share Feedback Link",
      description: "Access your business details and share feedback link with your team.",
      buttonLabel: "View Details",
      icon: <BusinessIcon />,
      color: "#00796b",
      route: "/business/details",
    },
    {
      title: "View Team's Feedbacks",
      description: "Check feedback received from your team.",
      buttonLabel: "View Feedbacks",
      icon: <FeedbackIcon />,
      color: "#d32f2f",
      route: "/business/feedbacks",
    },
    {
      title: "View Feedback Stats",
      description: "Analyze feedback trends and stats.",
      buttonLabel: "View Stats",
      icon: <InsightsIcon />,
      color: "#388e3c",
      route: "/business/feedback-stats",
    },
  ];

  return (
    <Grid container spacing={4} justifyContent="center">
      {cardData.map((card, index) => (
        <DashboardCard key={index} {...card} />
      ))}
    </Grid>
  );
};

export default BusinessDashboard;
